module.exports = {"name":"log","menu":{"label":"Registro de Atividades","route":"/atividades","parent":"menuLog","weight":10}}


//////////////////
// WEBPACK FOOTER
// ./_source/javascripts/modules/log/config.json
// module id = 383
// module chunks = 0